export const formatPercent = (value: number | null) => (value == null ? '—' : `${value}%`);

export const formatHours = (hours: number) =>
  hours < 24 ? `${hours}h` : `${Math.round((hours / 24) * 10) / 10}d`;

export const formatMonthRange = (from: string, to: string) => {
  const fmt = (raw: string) =>
    new Date(raw).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  return `${fmt(from)} a ${fmt(to)}`;
};

export const smsCostTone = (costPercentOfMrr: number | null) => {
  const negative = costPercentOfMrr != null && costPercentOfMrr >= 100;
  const heavy = costPercentOfMrr != null && costPercentOfMrr >= 40 && costPercentOfMrr < 100;
  return { negative, heavy };
};
